module.exports = __webpack_public_path__ + "assets/img/sub-type-3.a88da737.svg";